import { useMemo, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import PatientInfo from './tabs/PatientInfo';
import SurveyHistoryList from './tabs/SurveyHistoryList';
import TreatmentHistory from './tabs/TreatmentHistory';
import { Row, TypographyText } from 'components/UI/atoms';

const PatientDetailTab = ({ isGlobalLoading }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tab = queryParams.get('tab') ?? sessionStorage.getItem('patientDetailTab') ?? 'patientInfo';

  const tabList = useMemo(
    () => [
      {
        tabId: 'patientInfo',
        tabName: '환자정보',
      },
      {
        tabId: 'treatmentHistory',
        tabName: '진료내역',
      },
      {
        tabId: 'surveyHistory',
        tabName: '설문내역',
      },
    ],
    [],
  );
  const [selectedTab, setSelectedTab] = useState(tab);

  useEffect(() => {
    const url = new URL(window.location.href);
    url.search = ''; // 쿼리 파라미터 제거
    window.history.replaceState({}, '', url.toString());
    return () => {
      sessionStorage.removeItem('patientDetailTab');
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem('patientDetailTab', selectedTab);
  }, [selectedTab]);

  return (
    <Row
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        flex: '1 1 0',
      }}
    >
      <Row
        style={{
          display: 'flex',
          columnGap: '2rem',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        {tabList.map((tab, index) => (
          <div
            key={tab.tabId}
            style={{
              display: 'flex',
              alignItems: 'start',
              justifyContent: 'center',
              height: '2.2rem',
              cursor: 'pointer',
              borderBottom: `2px solid ${selectedTab === tab.tabId ? '#1c252c' : 'transparent'}`,
            }}
            onClick={() => {
              setSelectedTab(tab.tabId);
            }}
          >
            <TypographyText
              color={selectedTab === tab.tabId ? '#1c252c' : '#AFAFAF'}
              fontSize="1.2rem"
              lineHeight="1.2em"
              fontWeight={700}
            >
              {tab.tabName}
            </TypographyText>
          </div>
        ))}
      </Row>
      {selectedTab === 'patientInfo' && <PatientInfo isGlobalLoading={isGlobalLoading} />}
      {selectedTab === 'surveyHistory' && <SurveyHistoryList />}
      {selectedTab === 'treatmentHistory' && <TreatmentHistory />}
    </Row>
  );
};

export default PatientDetailTab;
